/**
 * Utilities for storing user data between pages and visits
 */

export const LoginFormInitData = 'LoginFormInitData';
